// extracted by mini-css-extract-plugin
export const analysisPage = "AnalysisSidebar-module__analysis-page--LRfWT";
export const analysisSidebar = "AnalysisSidebar-module__analysis-sidebar--bDADj";
export const baseTiming = "125ms";
export const baseTimingInt = "125";
export const baseVariableTag = "AnalysisSidebar-module__base-variable-tag--U2Ti-";
export const borderRadius = "3px";
export const charcoal = "#2d2e2e";
export const cloudGrey = "#c8cdcf";
export const content = "AnalysisSidebar-module__content--C3usc";
export const doveGrey = "#f1f3f5";
export const header = "AnalysisSidebar-module__header--s6-+U";
export const inRoute = "AnalysisSidebar-module__in-route--tVOnx";
export const kendoTooltip = "AnalysisSidebar-module__kendo-tooltip--8-ctc";
export const khBlue = "#04b1e0";
export const khBlueDark = "#0376ae";
export const khBlueLight = "#7de1f4";
export const lemon = "#fae436";
export const lemonDark = "#e3cd02";
export const lemonLight = "#fff284";
export const lime = "#05c150";
export const limeDark = "#068230";
export const limeLight = "#65ec83";
export const navy = "#052976";
export const navyDark = "#04173f";
export const navyLight = "#82b1f6";
export const overlayOpen = "AnalysisSidebar-module__overlay-open--CNr+v";
export const rowColContainer = "AnalysisSidebar-module__row-col-container--9JhET";
export const scarlet = "#e9062b";
export const scarletDark = "#9d050e";
export const scarletLight = "#f5726d";
export const stormGrey = "#969b9c";
export const violet = "#d401f8";
export const violetDark = "#9003a8";
export const violetLight = "#e77ef9";
export const white = "#fff";